<template lang="pug">
v-navigation-drawer(app v-model.boolean="showAppDrawer" v-if="!isKioskMode" clipped)
    UserQrCode(v-if="showQrCode" :show="showQrCode" @close="closeQrDialog")
    v-layout(column)
        v-list
            v-list-item(v-if="getDrawerItem"
                v-for="(item, idx) in getDrawerItem" :key="idx"
                :to="{name: item.routeName, params: item.routeParams}"
            )
                v-list-item-action
                    v-icon {{ item.icon }}
                v-list-item-content  {{ item.label }}
            v-list-item(@click="onQrCodeClick" v-if="showCustomerQrCode")
                v-list-item-action
                    v-icon fal fa-qrcode
                v-list-item-content  {{$t('navigationItem.qrCodeLabel')}}
</template>

<script lang="ts">
import Vue from 'vue'
import {APP_DRAWER_STATE, GET_MODE, NAVIGATION_DRAWER_ITEMS, SETTINGS_ALL, USER_LOGGED_IN} from '@/store/getter-types'
import {FETCH_TENANT_NAME, SET_DRAWER_STATE} from '@/store/action-types'
import { NavigationItem } from '@/types'
import UserQrCode from "@/components/dashboard/UserQrCode.vue";
import {CurrentUser} from "@/model/CurrentUser";
import {usePiniaStore} from "@/store/piniaStore";
import {SettingsItem} from "@/model/SettingsItem";


interface ComponentData {
  showQrCode: boolean,
  showCustomerQrCode: boolean,
  piniaStore: any,
  drawerItem:NavigationItem[],
  settingsData: any[],
  dashboardApp: boolean,
  dailyMenu: boolean,
  credit: boolean,
  billingApp: boolean,
  myOrders: boolean,
}


export default Vue.extend({
  name: 'AppDrawer',


  data(): ComponentData {
    return {
      showQrCode: false,
      showCustomerQrCode: false,
      piniaStore: usePiniaStore(),
      drawerItem: [],
      settingsData: [],
      dashboardApp: false,
      dailyMenu: false,
      credit: false,
      billingApp: false,
      myOrders: false,
    }
  },

  components: {
    UserQrCode
  },


  computed: {
    getDrawerItem() {
      let data: any | null = null
      let array:any[]= []
      let filteredData: any[] = []
      data = this.settingsData.find((item: any) => item.key === "tenant.app_main_menu_structure")
      if(data && data.value !== '[]') {
        array = JSON.parse(data.value);
      } else  {
        filteredData = this.drawerItem
      }

      if(array) {
        this.drawerItem.forEach((i:any) => {
          if(array.includes(i.key)){
            filteredData.push(i)
          }
        })

      }

      return filteredData

    },

    currentUser(): CurrentUser {
      return this.$store.getters[USER_LOGGED_IN]
    },

    isKioskMode(): boolean {
      return this.$store.getters[GET_MODE] === 'kiosk'
    },



    appSettings(): SettingsItem[] {
      return this.$store.getters[SETTINGS_ALL]
    },

    showAppDrawer: {
      get(): boolean {
        return this.$store.getters[APP_DRAWER_STATE]
      },

      set(newVal: boolean): void {
        this.$store.dispatch(SET_DRAWER_STATE, newVal)
      }
    }
  },

  methods: {
    onQrCodeClick(): void {
      this.showQrCode = true
    },

    closeQrDialog(): void {
      this.showQrCode = false
    },

    async fetchCustomer(): Promise<void> {
      let payload: any = this.currentUser.boarderList[0].customer.id
      try {
        const response = await this.piniaStore.fetchCustomerQrConfiguration(payload)
        this.showCustomerQrCode = response.configuration.show_boarder_card || false
      } catch (e) {
      } finally {

      }
    },

    async fetchSettingsData(): Promise<void> {
      try {
        this.settingsData = await this.$store.dispatch(FETCH_TENANT_NAME)
      } catch (e) {
      } finally {
      }
    }

  },
  created() {
    this.drawerItem = this.$store.getters[NAVIGATION_DRAWER_ITEMS]
    this.fetchSettingsData()
  },

  mounted() {
    this.fetchCustomer()
  }

})
</script>

<style lang="stylus" scoped>

</style>
